import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { ChannelSelection, ColorMapEntry, Sld } from '../../data/sld';
import { WMSRecord } from '../../data/wmsrecord';
import { UserService } from '../../user.service';
import { NgForOf, NgIf } from '@angular/common';

@Component({
  standalone: false,  // this is now required when using NgModule
  selector: 'app-sldeditor',
  templateUrl: './sldeditor.component.html',
  styleUrls: ['./sldeditor.component.css']
})
export class SldeditorComponent implements OnInit {

  @Input() sldEditorItem:WMSRecord|undefined;
  @Output() sldUpdated = new EventEmitter<WMSRecord>();

  slds: Sld[] = [];
  editorSld: Sld|undefined = undefined;
  templateSld: Sld|undefined = undefined;
  defaultSld: Sld;

  constructor(public userService: UserService, private ref: ChangeDetectorRef) { 
    this.defaultSld = new Sld();
    this.defaultSld.id = 0;
    this.defaultSld.name = 'default';
    this.defaultSld.builtin = true;
    this.defaultSld.gray = new ChannelSelection('1',undefined,undefined);
  }

  ngOnInit(): void {
    if (this.sldEditorItem && this.sldEditorItem.sld) {
      this.editorSld = this.sldEditorItem.sld;
    } else {
      this.editorSld = new Sld();
      this.editorSld.colormap.push(new ColorMapEntry('0', '#000000'));
      this.editorSld.colormap.push(new ColorMapEntry('255', '#FFFFFF'));
    }
    this.readSlds();
  }

  showSingleBand(): void {
    if (this.editorSld) {
      this.editorSld.singleBand = true;
    }
  }

  showMultiBand(): void {
    if (this.editorSld) {
      this.editorSld.singleBand = false;
    }
  }

  // Populate the style editor view with stored values
  sldSelectionChanged() {
    let dropdown = document.getElementById('sldmenu') as HTMLSelectElement;

    this.editorSld = JSON.parse(JSON.stringify(this.slds[dropdown.selectedIndex]));
    this.templateSld = this.editorSld;
  }

  parseSld() {
    if (!this.editorSld) {
      return undefined;
    }
    let sld = new Sld();
    if (this.editorSld.singleBand) {
      sld.singleBand = true;
      let band = (document.getElementById('sldgrayband') as HTMLInputElement).value;
      let minValue = (document.getElementById('sldgraybandmin') as HTMLInputElement).value;
      let maxValue = (document.getElementById('sldgraybandmax') as HTMLInputElement).value;
      if (band != '') {
        sld.gray = new ChannelSelection(band, minValue, maxValue);
      }

      let table = document.getElementById('sldTable');
      let quantityInputs = table?.getElementsByClassName('sldQuantityInput');
      let colorInputs = table?.getElementsByClassName('sldColorInput');
      let alphaInputs = table?.getElementsByClassName('sldAlphaInput');
      let cm: ColorMapEntry[] = [];
      if (quantityInputs && colorInputs && alphaInputs) {
        for (let i = 0; i < quantityInputs.length; i++) {
          cm.push(new ColorMapEntry(
            (quantityInputs[i] as HTMLInputElement).value, 
            (colorInputs[i] as HTMLInputElement).value,
            Number((alphaInputs[i] as HTMLInputElement).value)));
        }
      }
      sld.colormap = cm;
    } else {
      sld.singleBand = false;
      let band = (document.getElementById('sldredband') as HTMLInputElement).value;
      let minValue = (document.getElementById('sldredbandmin') as HTMLInputElement).value;
      let maxValue = (document.getElementById('sldredbandmax') as HTMLInputElement).value;
      if (band != '') {
        sld.red = new ChannelSelection(band, minValue, maxValue);
      }
      band = (document.getElementById('sldgreenband') as HTMLInputElement).value;
      minValue = (document.getElementById('sldgreenbandmin') as HTMLInputElement).value;
      maxValue = (document.getElementById('sldgreenbandmax') as HTMLInputElement).value;
      if (band != '') {
        sld.green = new ChannelSelection(band, minValue, maxValue);
      }
      band = (document.getElementById('sldblueband') as HTMLInputElement).value;
      minValue = (document.getElementById('sldbluebandmin') as HTMLInputElement).value;
      maxValue = (document.getElementById('sldbluebandmax') as HTMLInputElement).value;
      if (band != '') {
        sld.blue = new ChannelSelection(band, minValue, maxValue);
      }
    }

    return sld;
  }

  applySld() {
    let sld = this.parseSld();
    this.editorSld = sld; 
    //console.log(JSON.stringify(sld));
    if (this.sldEditorItem) {
      this.sldEditorItem.sld = this.editorSld;
      this.sldUpdated.emit(this.sldEditorItem);
    }
 };

  saveSld() {
    let name = window.prompt("Please give name for the saved custom style. Using an existing name overwrites the old style.", "");
    if (name == null) {
      return;
    }
    if (name == this.defaultSld.name) {
      window.alert('Default style cannot be overdriven, please select another name!');
    } else if (name == '') {
      window.alert('Name cannot be empty!');
    } else {
      let sld = this.parseSld();
      if (sld) {
        let customSldString = localStorage.getItem('slds');
        let customSlds;
        if (customSldString) {
          customSlds = JSON.parse(customSldString);
        } else {
          customSlds = {};
        }
        console.log(customSlds);
        sld.name = name;
        customSlds[sld.name] = sld;
        localStorage.setItem('slds', JSON.stringify(customSlds));
        console.log(customSlds);
      } else {
        window.alert('Failed to parse SLD!');
      }
      //MapService.getSlds();
      this.readSlds();
    }
  }

  deleteSld(): void {
    if (this.templateSld && this.templateSld.name) {
      if (this.templateSld.builtin) {
        window.alert('Built-in styles cannot be deleted');
      } else {
        let customSldString = localStorage.getItem('slds');
        if (customSldString) { 
          let customSlds = JSON.parse(customSldString);
          delete customSlds[this.templateSld.name];
          localStorage.setItem('slds', JSON.stringify(customSlds));
          
          // Update SLD list
          //MapService.getSlds();
          this.readSlds();
        }
      }
    }
  }

  resetDefaultSld(): void {
    if (this.sldEditorItem?.defaultSld) {
      this.editorSld = this.sldEditorItem.defaultSld.copy(); 
      this.sldEditorItem.sld = this.editorSld;
      this.sldUpdated.emit(this.sldEditorItem);
    }
  }

  readSlds(): void {
    this.slds = [ this.defaultSld ];
    this.userService.getServerSlds()?.subscribe((data: any) => {
        if ('slds' in data) {
          for (let item of data.slds) {
            let sld = Sld.fromJson(item);
            console.log(sld);
            if (sld) {
              this.slds.push(sld);
            }
          }
        }
        let customSldString = localStorage.getItem('slds');
        if (customSldString) {
          //console.log(customSldString);
          let customSlds = JSON.parse(customSldString);
          //console.log(customSlds);
          for (var key of Object.keys(customSlds)) {
            //console.log(customSlds[key]);
            this.slds.push(customSlds[key] as Sld);
          }
        }
        this.ref.markForCheck();
      }, (error:any)=>{
        console.log('ERROR in getServerSlds'); //TODO: messages
      });
    }
  
  newSldRowBelow($event:any) {
    let index = $event.currentTarget.parentNode.rowIndex;
    if (this.editorSld) {
      this.editorSld.colormap.splice(index, 0, new ColorMapEntry('0','#FFFFFF'));
    }
  }
  newSldRowAbove($event: any) {
    let index = $event.currentTarget.parentNode.rowIndex - 1;
    if (this.editorSld) {
      this.editorSld.colormap.splice(index, 0, new ColorMapEntry('0','#FFFFFF'));
    }
  }
  deleteSldRow($event: any) {
    let index = $event.currentTarget.parentNode.rowIndex - 1; // -1 because of header row
    if (this.editorSld) {
      this.editorSld.colormap.splice(index, 1);
    }
  }
  addColormapTemplate() {
    if (this.editorSld) {
      this.editorSld.colormap.push(new ColorMapEntry('0','#000000'));
      this.editorSld.colormap.push(new ColorMapEntry('255','#FFFFFF'));
    }
  }
}
